import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["dir"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "emh-stage-campaign__items-temporary" }, [
  /*#__PURE__*/_createElementVNode("div", { slot: "emh-stage-campaign-items" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_emh_stage_campaign_item = _resolveComponent("emh-stage-campaign-item")!
  const _component_wb_slider = _resolveComponent("wb-slider")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "hostRef",
    dir: _ctx.dir,
    class: _normalizeClass(["emh-stage-campaign__inner-wrapper wb-new-colors", {
      '-paused': _ctx.paused,
    }])
  }, [
    _hoisted_2,
    (_ctx.limitedItemsDatajson && _ctx.limitedItemsDatajson.length)
      ? (_openBlock(), _createBlock(_component_wb_slider, {
          key: 0,
          ref: "sliderRef",
          class: _normalizeClass({
        '-paused': _ctx.paused,
      }),
          "scroll-snap": "",
          "show-dot-navigation": "",
          "hide-arrow-navigation": "",
          "auto-rotate-interval-ms": 0,
          theme: _ctx.theme
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitedItemsDatajson, (datajson, i) => {
              return (_openBlock(), _createBlock(_component_emh_stage_campaign_item, {
                key: datajson,
                datajson: datajson,
                index: i,
                class: "wb-slider__item wb-slider__item--full-width emh-stage-campaign-item",
                onPopupsOpen: _ctx.onPopupsOpen,
                onPopupsClose: _ctx.onPopupsClose,
                onThemeChange: _ctx.onItemThemeChange
              }, null, 8, ["datajson", "index", "onPopupsOpen", "onPopupsClose", "onThemeChange"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["class", "theme"]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}